import { ActionTree } from 'vuex';
import RootState from '@/store/root_state';
import { chimeraQuery } from '@/helpers/graphql';
import { changeExperimentPlatformMigration } from '../../mutations/chimeraMutations';

const actions: ActionTree<RootState, RootState> = {
  async UPDATE_HAS_MIGRATED_TO_CLASSROOMS() {
    const response = await chimeraQuery(changeExperimentPlatformMigration);
    const responseStatus = !!response.data.chimera?.upsertUserExperimentsPlatformMigration; // it will return a string 'ok' in success or null in fail

    return responseStatus;
  },
};

export default actions;
